import DefaultLoader from 'components/Loader';
import DefaultSWDLogo from 'components/SWDLogo';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Page = styled.div`
  background-color: ${({ theme }) => theme.colors.grey200};
  display: flex;
  justify-content: center;
  padding: 2.5rem 1rem;

  ${from.tablet`
    padding: 4.375rem 1.5rem;
  `}
`;

export const Card = styled.section`
  width: 100%;
  max-width: 42.5rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey300};
  border-radius: 1rem;
  box-shadow: -13px 13px 30px -23px rgba(112, 111, 111, 0.3);
  padding: 1.5rem;

  ${from.tablet`
    padding: 2.5rem;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.75rem;
`;

export const Logo = styled(DefaultSWDLogo)`
  width: 11.95rem;
  height: auto;
`;

export const Loader = styled(DefaultLoader)`
  min-height: 50vh;
  align-items: center;
`;

export const StateContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 1rem;
`;

export const StateTitle = styled.h2`
  font-size: 1.5rem;
  margin: 0 0 0.75rem 0;
`;

export const StateSubtitle = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
`;
